var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonMultiSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 3.8H13.638C13.26 2.756 12.27 2 11.1 2C9.93 2 8.94 2.756 8.562 3.8H4.8C3.81 3.8 3 4.61 3 5.6V18.2C3 19.19 3.81 20 4.8 20H17.4C18.39 20 19.2 19.19 19.2 18.2V5.6C19.2 4.61 18.39 3.8 17.4 3.8ZM11.1 3.8C11.595 3.8 12 4.205 12 4.7C12 5.195 11.595 5.6 11.1 5.6C10.605 5.6 10.2 5.195 10.2 4.7C10.2 4.205 10.605 3.8 11.1 3.8ZM11.1 7.4C12.594 7.4 13.8 8.606 13.8 10.1C13.8 11.594 12.594 12.8 11.1 12.8C9.606 12.8 8.4 11.594 8.4 10.1C8.4 8.606 9.606 7.4 11.1 7.4ZM16.5 18.2H5.7V16.94C5.7 15.14 9.3 14.15 11.1 14.15C12.9 14.15 16.5 15.14 16.5 16.94V18.2Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonMultiSelectIcon);
export default __webpack_public_path__ + "static/media/PersonMultiSelectIcon.b5a05f9416e79936998ee4bedd078259.svg";
export { ForwardRef as ReactComponent };